import { addDays, differenceInCalendarDays, format, isValid, parseISO, startOfDay } from "date-fns";

export const SEARCH_DATE_ROLLOVER_DAYS = 7;

const normalizeMode = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === "experiences" || raw === "experience") return "experiences";
  if (raw === "itinerary" || raw === "itinerary-planner") return "itinerary";
  return "stays";
};

export const parseSearchDateValue = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return null;
  const isoMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoMatch?.[1]) {
    const parsedIso = parseISO(isoMatch[1]);
    return isValid(parsedIso) ? startOfDay(parsedIso) : null;
  }
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : startOfDay(parsed);
};

export const formatSearchDateValue = (value) => {
  if (!(value instanceof Date) || !isValid(value)) return "";
  return format(value, "yyyy-MM-dd");
};

export const getSearchDateRolloverTarget = (baseDate = new Date()) =>
  addDays(startOfDay(baseDate), SEARCH_DATE_ROLLOVER_DAYS);

export const normalizeBookingSearchDates = ({
  mode = "stays",
  startDate = "",
  endDate = "",
  baseDate = new Date(),
} = {}) => {
  const normalizedMode = normalizeMode(mode);
  const today = startOfDay(baseDate);
  const rolloverTarget = getSearchDateRolloverTarget(baseDate);
  const parsedStart = parseSearchDateValue(startDate);
  const parsedEnd = parseSearchDateValue(endDate);
  const originalNights =
    parsedStart && parsedEnd ? Math.max(0, differenceInCalendarDays(parsedEnd, parsedStart)) : 0;

  let nextStart = parsedStart;
  let nextEnd = parsedEnd;
  let rolledForward = false;

  if (nextStart && nextStart < today) {
    nextStart = rolloverTarget;
    rolledForward = true;
  }

  if (normalizedMode === "stays") {
    if (!nextStart) {
      nextEnd = null;
    } else if (rolledForward) {
      nextEnd = addDays(nextStart, Math.max(1, originalNights || 1));
    } else if (nextEnd && differenceInCalendarDays(nextEnd, nextStart) <= 0) {
      nextEnd = addDays(nextStart, Math.max(1, originalNights || 1));
    }
  } else if (nextStart && nextEnd && differenceInCalendarDays(nextEnd, nextStart) <= 0) {
    nextEnd = null;
  }

  return {
    startDate: formatSearchDateValue(nextStart),
    endDate: formatSearchDateValue(nextEnd),
  };
};
